import React from 'react';
import './ContactForm.css'
import FormInput from '../Common/FormInput';
import Button from '../Common/Button';

const ContactForm = () => {
    return ( 
        <form className='ContactForm' action="">
            <FormInput InputName="Full Name *" InputType="text"/>
            <FormInput InputName="Email Address *" InputType="email"/>
            <FormInput InputName="Phone Number" InputType="text"/>
            <FormInput InputName="Subject *" InputType="text"/>
            <div className='Message'>
                <label>Message*</label>
                <textarea></textarea>
            </div>
            <Button BtnText="Send Message"/>
        </form>
     );
}
 
export default ContactForm;